import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  icon: string;
  title: string;
  subtitle?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeading({
  icon,
  title,
  subtitle,
  linkTo,
  linkLabel = '查看全部',
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-600">
          <i className={`${icon} text-lg`}></i>
        </span>
        <div>
          <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">{title}</h2>
          {subtitle && <p className="mt-0.5 text-xs text-foreground-500 md:text-sm">{subtitle}</p>}
        </div>
      </div>
      {linkTo && (
        <Link
          to={linkTo}
          className="flex flex-shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-500 transition-colors hover:text-primary-600"
        >
          {linkLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}